import React, { useEffect, useState } from "react";
import OrderSchduletable, { AvatarCell } from "./OrderSchduletable"; // new

function OrderSchdule() {
  const data = [
    {
      schedule: "The Name of Schedule",
      person: "Dutch Grown",
    },
    {
      schedule: "The Name of Schedule",
      person: "Cambo",
    },
    {
      schedule: "The Name of Schedule",
      person: "Avon Bulbs",
    },
    {
      schedule: "The Name of Schedule",
      person: "Broardleight Bulbs",
    },
  ];

  const columns = React.useMemo(
    () => [
      {
        Header: "Schedule name",
        accessor: "schedule",
      },
      {
        Header: "Person",
        accessor: "person",
        Cell: AvatarCell,
      },

      {
        Header: "Date Order",
        accessor: "dateorder",
        Cell: (value) => (
            <div className="flex flex-wrap bg-blue-50 border-2 pl-3 shadow-md rounded-3xl">
            <div className="flex flex-wrap float-left ">
              <div className=" text-gray-900 py-4 font-medium ">
                {" "}
                <svg
                  width="22"
                  height="19"
                  viewBox="0 0 22 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.8122 6.30951H0.90932C0.635938 6.30951 0.414062 6.1333 0.414062 5.91619V3.84382C0.414062 2.78836 1.49521 1.92975 2.82423 1.92975H18.8973C20.2261 1.92975 21.3072 2.78836 21.3072 3.84382V5.91639C21.3075 6.1335 21.0856 6.30951 20.8122 6.30951ZM1.40458 5.52288H20.317V3.84362C20.317 3.22199 19.6803 2.71618 18.8976 2.71618H2.82423C2.04123 2.71618 1.40458 3.22199 1.40458 3.84362V5.52288Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M10.3977 18.3441H2.82423C1.49521 18.3441 0.414062 17.4854 0.414062 16.43V5.91383C0.414062 5.69671 0.635938 5.52051 0.90932 5.52051H20.8122C21.0856 5.52051 21.3075 5.69671 21.3075 5.91383V9.67985C21.3075 9.89696 21.0856 10.0732 20.8122 10.0732C20.5389 10.0732 20.317 9.89696 20.317 9.67985V6.30714H1.40458V16.4298C1.40458 17.0514 2.04148 17.5572 2.82423 17.5572H10.3977C10.6711 17.5572 10.893 17.7334 10.893 17.9505C10.893 18.1677 10.6713 18.3441 10.3977 18.3441Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M4.87805 3.99841C4.60468 3.99841 4.38281 3.82221 4.38281 3.6051V1.03968C4.38281 0.822569 4.60468 0.646362 4.87805 0.646362C5.15142 0.646362 5.37329 0.822569 5.37329 1.03968V3.6051C5.37329 3.82221 5.15167 3.99841 4.87805 3.99841Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M16.839 3.99841C16.5656 3.99841 16.3438 3.82221 16.3438 3.6051V1.03968C16.3438 0.822569 16.5656 0.646362 16.839 0.646362C17.1124 0.646362 17.3342 0.822569 17.3342 1.03968V3.6051C17.3342 3.82221 17.1124 3.99841 16.839 3.99841Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M10.8624 3.99841C10.5891 3.99841 10.3672 3.82221 10.3672 3.6051V1.03968C10.3672 0.822569 10.5891 0.646362 10.8624 0.646362C11.1358 0.646362 11.3577 0.822569 11.3577 1.03968V3.6051C11.3577 3.82221 11.1358 3.99841 10.8624 3.99841Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M4.87093 8.90326H4.49479C4.32518 8.90326 4.1875 8.79411 4.1875 8.6592V8.36046C4.1875 8.22574 4.32493 8.11639 4.49479 8.11639H4.87093C5.04055 8.11639 5.17822 8.22554 5.17822 8.36046V8.6592C5.17822 8.79411 5.04079 8.90326 4.87093 8.90326Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M8.98812 8.90326H8.61198C8.44236 8.90326 8.30469 8.79411 8.30469 8.6592V8.36046C8.30469 8.22574 8.44212 8.11639 8.61198 8.11639H8.98812C9.15773 8.11639 9.29541 8.22554 9.29541 8.36046V8.6592C9.29541 8.79411 9.15798 8.90326 8.98812 8.90326Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M13.1053 8.90326H12.7292C12.5596 8.90326 12.4219 8.79411 12.4219 8.6592V8.36046C12.4219 8.22574 12.5593 8.11639 12.7292 8.11639H13.1053C13.2749 8.11639 13.4126 8.22554 13.4126 8.36046V8.6592C13.4126 8.79411 13.2752 8.90326 13.1053 8.90326Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M17.2225 8.90326H16.8464C16.6767 8.90326 16.5391 8.79411 16.5391 8.6592V8.36046C16.5391 8.22574 16.6765 8.11639 16.8464 8.11639H17.2225C17.3921 8.11639 17.5298 8.22554 17.5298 8.36046V8.6592C17.5295 8.79411 17.3921 8.90326 17.2225 8.90326Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M4.87093 12.1732H4.49479C4.32518 12.1732 4.1875 12.064 4.1875 11.9291V11.6304C4.1875 11.4957 4.32493 11.3864 4.49479 11.3864H4.87093C5.04055 11.3864 5.17822 11.4955 5.17822 11.6304V11.9291C5.17822 12.064 5.04079 12.1732 4.87093 12.1732Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M8.98812 12.1732H8.61198C8.44236 12.1732 8.30469 12.064 8.30469 11.9291V11.6304C8.30469 11.4957 8.44212 11.3864 8.61198 11.3864H8.98812C9.15773 11.3864 9.29541 11.4955 9.29541 11.6304V11.9291C9.29541 12.064 9.15798 12.1732 8.98812 12.1732Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M4.87093 15.4464H4.49479C4.32518 15.4464 4.1875 15.3373 4.1875 15.2023V14.9036C4.1875 14.7689 4.32493 14.6595 4.49479 14.6595H4.87093C5.04055 14.6595 5.17822 14.7687 5.17822 14.9036V15.2023C5.17822 15.3373 5.04079 15.4464 4.87093 15.4464Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M8.98812 15.4464H8.61198C8.44236 15.4464 8.30469 15.3373 8.30469 15.2023V14.9036C8.30469 14.7689 8.44212 14.6595 8.61198 14.6595H8.98812C9.15773 14.6595 9.29541 14.7687 9.29541 14.9036V15.2023C9.29541 15.3373 9.15798 15.4464 8.98812 15.4464Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M16.2512 18.3475C13.4633 18.3475 11.1953 16.5463 11.1953 14.3323C11.1953 12.1181 13.4633 10.3169 16.2512 10.3169C19.039 10.3169 21.307 12.1181 21.307 14.3323C21.307 16.5463 19.0387 18.3475 16.2512 18.3475ZM16.2512 11.1035C14.0094 11.1035 12.1858 12.5519 12.1858 14.3323C12.1858 16.1126 14.0094 17.5608 16.2512 17.5608C18.4929 17.5608 20.3165 16.1126 20.3165 14.3323C20.3165 12.5519 18.4927 11.1035 16.2512 11.1035Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M15.7338 15.7985C15.7298 15.7985 15.7258 15.7985 15.7219 15.7983C15.5825 15.7957 15.4507 15.7463 15.3594 15.6628L14.3084 14.6999C14.1294 14.5359 14.1517 14.2874 14.3585 14.1452C14.565 14.0032 14.8782 14.0203 15.057 14.1849L15.7514 14.8211L17.72 13.1837C17.9087 13.0262 18.2224 13.0209 18.42 13.1709C18.6179 13.321 18.6251 13.5698 18.4361 13.7269L16.0916 15.6769C15.9982 15.7546 15.869 15.7985 15.7338 15.7985Z"
                    fill="#1F78B4"
                  />
                </svg>
              </div>
              <div className="mt-3 mr-8 ml-2 text-gray-700 font-medium">
                21-oct-2021
              </div>
            </div>
            <div className="flex flex-wrap float-left ">
              <div className=" text-gray-900 py-4 font-medium ">
                {" "}
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.5 1.25C10.9462 1.25 13.75 4.05375 13.75 7.5C13.75 10.9462 10.9462 13.75 7.5 13.75C4.05375 13.75 1.25 10.9462 1.25 7.5C1.25 4.05375 4.05375 1.25 7.5 1.25ZM7.5 0C3.35813 0 0 3.35813 0 7.5C0 11.6419 3.35813 15 7.5 15C11.6419 15 15 11.6419 15 7.5C15 3.35813 11.6419 0 7.5 0ZM11.155 7.78687C11.2812 7.81062 11.2813 7.995 11.1556 8.01937C9.96375 8.245 7.3775 8.71375 7.06375 8.71375C6.61437 8.71375 6.25062 8.35 6.25062 7.90062C6.25062 7.58062 6.73187 4.49625 6.95375 3.2475C6.975 3.1275 7.14875 3.13438 7.16813 3.25625L7.78375 7.155L11.155 7.78687Z"
                    fill="#1F78B4"
                  />
                </svg>
              </div>
              <div className="mt-3  ml-2 text-gray-700 font-medium">
                02:45PM
              </div>
            </div>
            <div className="flex">
            <div class=" inline-flex w-16 mt-6 ml-4 mr-4 bg-blue-200 rounded-full h-0.5 "></div>
          </div>
            <div className="flex flex-wrap float-left ">
              <div className=" text-gray-900 py-4 font-medium ">
                {" "}
                <svg
                  width="22"
                  height="19"
                  viewBox="0 0 22 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.8122 6.30951H0.90932C0.635938 6.30951 0.414062 6.1333 0.414062 5.91619V3.84382C0.414062 2.78836 1.49521 1.92975 2.82423 1.92975H18.8973C20.2261 1.92975 21.3072 2.78836 21.3072 3.84382V5.91639C21.3075 6.1335 21.0856 6.30951 20.8122 6.30951ZM1.40458 5.52288H20.317V3.84362C20.317 3.22199 19.6803 2.71618 18.8976 2.71618H2.82423C2.04123 2.71618 1.40458 3.22199 1.40458 3.84362V5.52288Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M10.3977 18.3441H2.82423C1.49521 18.3441 0.414062 17.4854 0.414062 16.43V5.91383C0.414062 5.69671 0.635938 5.52051 0.90932 5.52051H20.8122C21.0856 5.52051 21.3075 5.69671 21.3075 5.91383V9.67985C21.3075 9.89696 21.0856 10.0732 20.8122 10.0732C20.5389 10.0732 20.317 9.89696 20.317 9.67985V6.30714H1.40458V16.4298C1.40458 17.0514 2.04148 17.5572 2.82423 17.5572H10.3977C10.6711 17.5572 10.893 17.7334 10.893 17.9505C10.893 18.1677 10.6713 18.3441 10.3977 18.3441Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M4.87805 3.99841C4.60468 3.99841 4.38281 3.82221 4.38281 3.6051V1.03968C4.38281 0.822569 4.60468 0.646362 4.87805 0.646362C5.15142 0.646362 5.37329 0.822569 5.37329 1.03968V3.6051C5.37329 3.82221 5.15167 3.99841 4.87805 3.99841Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M16.839 3.99841C16.5656 3.99841 16.3438 3.82221 16.3438 3.6051V1.03968C16.3438 0.822569 16.5656 0.646362 16.839 0.646362C17.1124 0.646362 17.3342 0.822569 17.3342 1.03968V3.6051C17.3342 3.82221 17.1124 3.99841 16.839 3.99841Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M10.8624 3.99841C10.5891 3.99841 10.3672 3.82221 10.3672 3.6051V1.03968C10.3672 0.822569 10.5891 0.646362 10.8624 0.646362C11.1358 0.646362 11.3577 0.822569 11.3577 1.03968V3.6051C11.3577 3.82221 11.1358 3.99841 10.8624 3.99841Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M4.87093 8.90326H4.49479C4.32518 8.90326 4.1875 8.79411 4.1875 8.6592V8.36046C4.1875 8.22574 4.32493 8.11639 4.49479 8.11639H4.87093C5.04055 8.11639 5.17822 8.22554 5.17822 8.36046V8.6592C5.17822 8.79411 5.04079 8.90326 4.87093 8.90326Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M8.98812 8.90326H8.61198C8.44236 8.90326 8.30469 8.79411 8.30469 8.6592V8.36046C8.30469 8.22574 8.44212 8.11639 8.61198 8.11639H8.98812C9.15773 8.11639 9.29541 8.22554 9.29541 8.36046V8.6592C9.29541 8.79411 9.15798 8.90326 8.98812 8.90326Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M13.1053 8.90326H12.7292C12.5596 8.90326 12.4219 8.79411 12.4219 8.6592V8.36046C12.4219 8.22574 12.5593 8.11639 12.7292 8.11639H13.1053C13.2749 8.11639 13.4126 8.22554 13.4126 8.36046V8.6592C13.4126 8.79411 13.2752 8.90326 13.1053 8.90326Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M17.2225 8.90326H16.8464C16.6767 8.90326 16.5391 8.79411 16.5391 8.6592V8.36046C16.5391 8.22574 16.6765 8.11639 16.8464 8.11639H17.2225C17.3921 8.11639 17.5298 8.22554 17.5298 8.36046V8.6592C17.5295 8.79411 17.3921 8.90326 17.2225 8.90326Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M4.87093 12.1732H4.49479C4.32518 12.1732 4.1875 12.064 4.1875 11.9291V11.6304C4.1875 11.4957 4.32493 11.3864 4.49479 11.3864H4.87093C5.04055 11.3864 5.17822 11.4955 5.17822 11.6304V11.9291C5.17822 12.064 5.04079 12.1732 4.87093 12.1732Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M8.98812 12.1732H8.61198C8.44236 12.1732 8.30469 12.064 8.30469 11.9291V11.6304C8.30469 11.4957 8.44212 11.3864 8.61198 11.3864H8.98812C9.15773 11.3864 9.29541 11.4955 9.29541 11.6304V11.9291C9.29541 12.064 9.15798 12.1732 8.98812 12.1732Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M4.87093 15.4464H4.49479C4.32518 15.4464 4.1875 15.3373 4.1875 15.2023V14.9036C4.1875 14.7689 4.32493 14.6595 4.49479 14.6595H4.87093C5.04055 14.6595 5.17822 14.7687 5.17822 14.9036V15.2023C5.17822 15.3373 5.04079 15.4464 4.87093 15.4464Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M8.98812 15.4464H8.61198C8.44236 15.4464 8.30469 15.3373 8.30469 15.2023V14.9036C8.30469 14.7689 8.44212 14.6595 8.61198 14.6595H8.98812C9.15773 14.6595 9.29541 14.7687 9.29541 14.9036V15.2023C9.29541 15.3373 9.15798 15.4464 8.98812 15.4464Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M16.2512 18.3475C13.4633 18.3475 11.1953 16.5463 11.1953 14.3323C11.1953 12.1181 13.4633 10.3169 16.2512 10.3169C19.039 10.3169 21.307 12.1181 21.307 14.3323C21.307 16.5463 19.0387 18.3475 16.2512 18.3475ZM16.2512 11.1035C14.0094 11.1035 12.1858 12.5519 12.1858 14.3323C12.1858 16.1126 14.0094 17.5608 16.2512 17.5608C18.4929 17.5608 20.3165 16.1126 20.3165 14.3323C20.3165 12.5519 18.4927 11.1035 16.2512 11.1035Z"
                    fill="#1F78B4"
                  />
                  <path
                    d="M15.7338 15.7985C15.7298 15.7985 15.7258 15.7985 15.7219 15.7983C15.5825 15.7957 15.4507 15.7463 15.3594 15.6628L14.3084 14.6999C14.1294 14.5359 14.1517 14.2874 14.3585 14.1452C14.565 14.0032 14.8782 14.0203 15.057 14.1849L15.7514 14.8211L17.72 13.1837C17.9087 13.0262 18.2224 13.0209 18.42 13.1709C18.6179 13.321 18.6251 13.5698 18.4361 13.7269L16.0916 15.6769C15.9982 15.7546 15.869 15.7985 15.7338 15.7985Z"
                    fill="#1F78B4"
                  />
                </svg>
              </div>
              <div className="mt-3 mr-8 ml-2 text-gray-700 font-medium">
                21-oct-2021
              </div>
            </div>
            <div className="flex flex-wrap float-left ">
              <div className=" text-gray-900 py-4 font-medium ">
                {" "}
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.5 1.25C10.9462 1.25 13.75 4.05375 13.75 7.5C13.75 10.9462 10.9462 13.75 7.5 13.75C4.05375 13.75 1.25 10.9462 1.25 7.5C1.25 4.05375 4.05375 1.25 7.5 1.25ZM7.5 0C3.35813 0 0 3.35813 0 7.5C0 11.6419 3.35813 15 7.5 15C11.6419 15 15 11.6419 15 7.5C15 3.35813 11.6419 0 7.5 0ZM11.155 7.78687C11.2812 7.81062 11.2813 7.995 11.1556 8.01937C9.96375 8.245 7.3775 8.71375 7.06375 8.71375C6.61437 8.71375 6.25062 8.35 6.25062 7.90062C6.25062 7.58062 6.73187 4.49625 6.95375 3.2475C6.975 3.1275 7.14875 3.13438 7.16813 3.25625L7.78375 7.155L11.155 7.78687Z"
                    fill="#1F78B4"
                  />
                </svg>
              </div>
              <div className="mt-3 mr-8 ml-2 text-gray-700 font-medium">
                09:30am
              </div>
            </div>
          </div>
        ),
      },
     
    ],
    []
  );

  return (
    <div className="mb-8 pb-4">
      <main className="max-w-full min-h-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="-mt-10">
          <OrderSchduletable
            columns={columns}
            data={data == undefined ? [] : data}
            text="Undefined"
          />
        </div>
      </main>
    </div>
  );
}

export default OrderSchdule;
